//
// TemplateLookup.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "../visualElements/VisualElement";
import "../promptDefinitions/PromptDefinition";
import "../dataDefinition/DataItem";

var TemplateLookup = createModule("BIRD::TemplateLookup", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        dataItem: 1,
        rowVariable: 7,
        rowIndex: 4,
        row: 4,
        prompt: 1,
        element: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TemplateLookup;
